import { Host, h } from "@stencil/core";
import { getShortcuts, loadShortcuts, unloadShortcuts } from "./ch-shortcuts-manager";
const KEY_SYMBOL = {
    " ": "\u2334"
};
export class ChShortcuts {
    constructor() {
        this.showShortcuts = false;
        this.src = undefined;
        this.showKey = "F10";
        this.suspend = false;
    }
    shortcuts;
    el;
    suspendHandler() {
        if (this.suspend) {
            unloadShortcuts(this.src);
        }
        else {
            const root = this.el.getRootNode();
            loadShortcuts(this.src, root, this.shortcuts);
        }
    }
    componentDidLoad() {
        if (this.src) {
            fetch(this.src).then(response => {
                if (response.ok) {
                    response.json().then(json => {
                        const root = this.el.getRootNode();
                        this.shortcuts = json;
                        loadShortcuts(this.src, root, this.shortcuts);
                    });
                }
            });
        }
    }
    disconnectedCallback() {
        unloadShortcuts(this.src);
    }
    windowKeyDownHandler(eventInfo) {
        const modifierKeys = ["Ctrl", "Alt", "Shift", "Meta"];
        if (eventInfo.repeat || this.suspend) {
            return;
        }
        if (eventInfo.key === this.showKey) {
            this.showShortcuts = !this.showShortcuts;
            eventInfo.preventDefault();
        }
        else if (this.showShortcuts && !modifierKeys.includes(eventInfo.key)) {
            this.showShortcuts = false;
        }
    }
    windowClosedHandler = () => {
        this.showShortcuts = false;
    };
    renderShortcuts() {
        return getShortcuts(this.src)
            .filter(shortcut => shortcut.element)
            .map(shortcut => (h("ch-window", { container: shortcut.element, modal: false, hidden: false, closeOnEscape: true, closeOnOutsideClick: true, xAlign: "outside-end", yAlign: "inside-start", onWindowClosed: this.windowClosedHandler, exportparts: "mask:element, main:tooltip" }, this.renderKeyShortcuts(shortcut.keyShortcuts))));
    }
    renderKeyShortcuts(keyShortcuts) {
        return keyShortcuts.split(/(?<!(?:[+]|^))([+\s])/).map((key, i, items) => {
            if (key === "+" && i > 0 && items[i - 1] !== "+") {
                return h("span", { part: "plus" }, "+");
            }
            if (key === " " && i > 0 && items[i - 1] !== "+") {
                return h("span", { part: "slash" }, "/");
            }
            return h("kbd", { part: `key` }, KEY_SYMBOL[key] ?? key);
        });
    }
    render() {
        return h(Host, { key: 'af8946782afcf28551c28c0385001521fbdd4fc4' }, this.showShortcuts && this.renderShortcuts());
    }
    static get is() { return "ch-shortcuts"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-shortcuts.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-shortcuts.css"]
        };
    }
    static get properties() {
        return {
            "src": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The URL of the shortcut definitions."
                },
                "attribute": "src",
                "reflect": false
            },
            "showKey": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"F10\"",
                    "resolved": "\"F10\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Key to show shortcut tooltips."
                },
                "attribute": "show-key",
                "reflect": false,
                "defaultValue": "\"F10\""
            },
            "suspend": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Suspend shortcuts."
                },
                "attribute": "suspend",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "showShortcuts": {}
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "suspend",
                "methodName": "suspendHandler"
            }];
    }
    static get listeners() {
        return [{
                "name": "keydown",
                "method": "windowKeyDownHandler",
                "target": "window",
                "capture": true,
                "passive": false
            }];
    }
}
